export const workingHoursPerWeek = 40;
export const numberOfWorkDaysPerYear = 173;

export const monthlyHours = (fullTimeHours?: number) =>
  fullTimeHours ? (fullTimeHours / workingHoursPerWeek) * numberOfWorkDaysPerYear : 1;

export const hourlySalary = (salary: number, hours: number) => (salary / hours).toFixed(2);
